import { ErrorPage } from '@sbercloud/uikit-product-error-pages';

import styles from './style.module.scss';

export function GlobalErrorPage() {
  return (
    <ErrorPage
      className={styles.error_page_wrapper}
      mainPageUrl={process.env.CONTENT_BASE_URL}
    />
  );
}
